import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { GuaranteeModal } from './GuaranteeModal';
import { Button } from '../../components/Button';
import { useOrderRoute } from '../../contexts/OrderContext';

export function Hero() {
  const navigate = useNavigate();
  const orderRoute = useOrderRoute();
  const [showGuarantee, setShowGuarantee] = useState(false);

  return (
    <section className="relative py-16 flex items-center">
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url('/images/no-tp-dont-panic.jpg')",
          backgroundPosition: 'left center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      />
      <div
        className="container mx-auto px-4 flex justify-center md:justify-end text-center md:text-right relative z-10"
        style={{ minHeight: '1px' }}
      >
        <div
          className="backdrop-blur-sm bg-white/70 border border-black/10 rounded-xl p-8 md:max-w-lg w-full text-black transition-all duration-300 flex flex-col items-center text-center"
          style={{
            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
          }}
        >
          <h2 className="text-4xl font-bold mb-4">NYC’s Cleanest Bidet Installation</h2>
          <p className="text-lg mb-6 py-4">We deliver, install, and show you how to use your new bidet—no mess, no stress, no plumber required. Experience a cleaner, greener, and more comfortable clean today.</p>
          <Button
            cta
            onClick={() => navigate(orderRoute)}
            style={{ minWidth: '180px', display: 'inline-block' }}
            className="mb-0"
          >
            Get a Bidet Installed
          </Button>
          <p className="text-sm font-medium text-gray-700 mt-6">
            <Button
              type="button"
              variant="text"
              className="underline text-blue-700 hover:text-blue-900 focus:outline-none cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                setShowGuarantee(true);
              }}
            >
              100% Money-back Guarantee
            </Button>
          </p>
        </div>
        <GuaranteeModal open={showGuarantee} onClose={() => setShowGuarantee(false)} />
      </div>
    </section>
  );
}
